// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3n-um","selected":"Chip_selected__1Vkfh"};